import React from "react";
import * as PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import GBDialog from "../GBDialog";
import Button from "@mui/material/Button";
import Loading from "../../components/Loading";

const styles = {
    pre: {
        fontSize: "12px",
    },
};

const RunHistoryDialogLog = ({ t, ...rest }) => {
    const { open, onClose, selectedRun, log, onFetchLog, onDownloadLog } = rest;

    const [loadingData, setLoadingData] = React.useState(false);

    React.useEffect(() => {
        if (selectedRun && typeof log === "undefined") {
            setLoadingData(true);
            onFetchLog(selectedRun.id);
        }
    }, [selectedRun, log, onFetchLog]);

    React.useEffect(() => {
        if (typeof log !== "undefined") {
            setLoadingData(false);
        }
    }, [log]);

    if (!open) {
        return null;
    }

    return (
        <GBDialog
            open={true}
            onClose={onClose}
            title={`${t("Log")} for ${selectedRun.name}`}
            content={
                <>
                    <Loading
                        loading={loadingData}
                        message={t("Loading log...")}
                    >
                        <pre style={styles.pre}>{log}</pre>
                    </Loading>
                </>
            }
            actions={
                <>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onDownloadLog(selectedRun.id)}
                    >
                        {t("Download log")}
                    </Button>
                </>
            }
        />
    );
};

RunHistoryDialogLog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    selectedRun: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        startedAt: PropTypes.instanceOf(Date).isRequired,
        completed: PropTypes.bool.isRequired,
    }),
    log: PropTypes.string,
    onFetchLog: PropTypes.func.isRequired,
    onDownloadLog: PropTypes.func.isRequired,
};

RunHistoryDialogLog.defaultProps = {};

export default withTranslation()(RunHistoryDialogLog);
